import type { Dictionary } from './en';

export const fr: Dictionary = {
  'common.cancel': 'Annuler',
  'common.back': 'Retour',
  'common.retry': 'Réessayer',
  'common.copy': 'Copier',
  'common.copied': 'Copié',
  'common.share': 'Partager',
  'common.delete': 'Supprimer',
  'common.revoke': 'Révoquer',
  'common.close': 'Fermer',
  'common.loading': 'Chargement',
  'common.optional': 'Optionnel',
  'common.or': 'ou',
  'common.none': 'Aucun',
  'common.required': 'Requis',
  'common.notSet': 'Non défini',
  'common.skipToContent': 'Aller au contenu principal',
  'common.moment': 'Un instant…',

  'brand.tagline': 'Partagez une vidéo. Une seule fois.',
  'brand.home': 'BOOMSHOT - accueil',
  'brand.footerLimit':
    "BOOMSHOT assure une lecture unique sécurisée. Aucune technologie ne peut empêcher une capture ou un enregistrement d'écran.",

  'nav.main': 'Navigation principale',
  'nav.myVideos': 'Mes vidéos',
  'nav.privacy': 'Confidentialité',
  'nav.signIn': 'Se connecter',
  'nav.signOut': 'Se déconnecter',
  'nav.settings': 'Paramètres du compte',
  'nav.openMenu': 'Ouvrir le menu',
  'nav.closeMenu': 'Fermer le menu',

  'theme.light': 'Thème clair - basculer vers sombre',
  'theme.dark': 'Thème sombre - basculer vers automatique',
  'theme.system': 'Thème automatique - basculer vers clair',
  'theme.label': 'Apparence',
  'theme.optionSystem': 'Automatique',
  'theme.optionLight': 'Clair',
  'theme.optionDark': 'Sombre',

  'language.label': 'Langue',
  'language.change': 'Changer de langue',

  'landing.title': 'Partagez une vidéo. Une seule fois.',
  'landing.subtitle':
    'Votre lien privé devient inutilisable après la première lecture et la vidéo est automatiquement supprimée.',
  'landing.ctaNew': 'Créer un lien privé',
  'landing.ctaSend': 'Envoyer une vidéo',
  'landing.haveAccount': "J'ai déjà un compte",
  'landing.assure.encrypted': 'Chiffré en transit',
  'landing.assure.deleted': 'Supprimé après lecture',
  'landing.assure.noReplay': 'Aucun replay',
  'landing.how': 'Trois étapes. Aucune seconde chance.',
  'landing.step1.title': 'Envoyez',
  'landing.step1.body':
    "Déposez une vidéo. Elle est convertie en fragments diffusés depuis un stockage privé, jamais depuis une URL publique.",
  'landing.step2.title': 'Configurez',
  'landing.step2.body':
    "Expiration, code d'accès, filigrane, message. Le lien porte un secret qui ne quitte jamais votre appareil.",
  'landing.step3.title': 'Une seule lecture',
  'landing.step3.body':
    'La première session réserve le lien de façon définitive. À la fin, les fichiers sont détruits côté serveur.',
  'landing.limits.title': 'Ce que BOOMSHOT fait',
  'landing.limits.guaranteed': 'Garanti côté serveur',
  'landing.limits.g1': 'Une seule session de lecture par lien, réservée de façon atomique.',
  'landing.limits.g2': 'Fragments servis sous jeton court, sans URL permanente.',
  'landing.limits.g3':
    'Suppression vérifiée du fichier source, des fragments et des miniatures.',

  'auth.signIn.title': 'Connexion',
  'auth.signIn.subtitle': 'Accédez à vos vidéos et à vos liens actifs.',
  'auth.signIn.submit': 'Se connecter',
  'auth.signIn.noAccount': 'Pas encore de compte ?',
  'auth.signIn.create': 'Créer un compte',
  'auth.signIn.magicLink': 'Recevoir un lien de connexion',
  'auth.signIn.usePassword': 'Utiliser un mot de passe',
  'auth.signIn.forgot': 'Mot de passe oublié',
  'auth.signIn.magicSent':
    "Si un compte existe pour cette adresse, un lien de connexion vient d'être envoyé. Il est valable une seule fois.",
  'auth.signUp.title': 'Créer un compte',
  'auth.signUp.subtitle':
    "Un compte est nécessaire pour envoyer. Vos destinataires, eux, n'en ont jamais besoin.",
  'auth.signUp.submit': 'Créer mon compte',
  'auth.signUp.hasAccount': 'Déjà inscrit ?',
  'auth.signUp.terms':
    "J'ai compris qu'une vidéo lue dans un navigateur peut toujours être capturée par un enregistrement d'écran, et que BOOMSHOT garantit une lecture unique, pas une protection anti-copie.",
  'auth.reset.title': 'Mot de passe oublié',
  'auth.reset.subtitle': 'Nous vous enverrons un lien de réinitialisation.',
  'auth.reset.submit': 'Envoyer le lien',
  'auth.reset.sent':
    "Si un compte existe pour cette adresse, un email de réinitialisation vient d'être envoyé. Pensez à vérifier vos indésirables.",
  'auth.reset.back': 'Retour à la connexion',
  'auth.callback.title': 'Connexion en cours',
  'auth.callback.subtitle': 'Vérification de votre lien…',
  'auth.callback.invalid': "Ce lien n'est pas un lien de connexion valide.",
  'auth.callback.requestNew': 'Demander un nouveau lien',
  'auth.google': 'Continuer avec Google',
  'auth.email': 'Adresse email',
  'auth.emailPlaceholder': 'vous@exemple.com',
  'auth.password': 'Mot de passe',
  'auth.passwordConfirm': 'Confirmer le mot de passe',
  'auth.passwordHint': '10 caractères minimum, avec majuscule, minuscule et chiffre.',
  'auth.magicHint': 'Vous recevrez un lien à usage unique, sans mot de passe.',
  'auth.confirmEmailPrompt': 'Confirmez votre adresse email pour terminer la connexion',

  'authError.invalidCredential': 'Adresse email ou mot de passe incorrect.',
  'authError.emailInUse':
    'Impossible de créer ce compte. Essayez de vous connecter ou de réinitialiser votre mot de passe.',
  'authError.weakPassword': 'Mot de passe trop faible.',
  'authError.tooManyRequests': 'Trop de tentatives. Réessayez dans quelques minutes.',
  'authError.network': 'Connexion indisponible. Vérifiez votre réseau.',
  'authError.popupClosed': 'Fenêtre fermée avant la fin de la connexion.',
  'authError.popupBlocked': 'La fenêtre a été bloquée par le navigateur.',
  'authError.recentLogin':
    'Pour des raisons de sécurité, reconnectez-vous avant de poursuivre.',
  'authError.invalidActionCode': 'Ce lien de connexion est invalide ou a déjà été utilisé.',
  'authError.expiredActionCode': 'Ce lien de connexion a expiré. Demandez-en un nouveau.',
  'authError.generic': 'Une erreur est survenue. Réessayez.',

  'dashboard.title': 'Mes vidéos',
  'dashboard.subtitle': "Chaque lien n'autorise qu'une seule session de lecture.",
  'dashboard.send': 'Envoyer une vidéo',
  'dashboard.metric.activeLinks': 'Liens actifs',
  'dashboard.metric.watched': 'Vidéos consultées',
  'dashboard.metric.storage': 'Stockage temporaire',
  'dashboard.search': 'Rechercher',
  'dashboard.searchPlaceholder': 'Rechercher par nom ou destinataire',
  'dashboard.filters': 'Filtres',
  'dashboard.filterStatus': 'Statut',
  'dashboard.filterAll': 'Tous les statuts',
  'dashboard.sort': 'Tri',
  'dashboard.sortNewest': 'Plus récentes',
  'dashboard.sortOldest': 'Plus anciennes',
  'dashboard.sortExpiring': 'Expiration proche',
  'dashboard.empty.title': "Aucune vidéo pour l'instant",
  'dashboard.empty.body':
    'Envoyez votre première vidéo : elle sera convertie, protégée par un lien à usage unique, puis supprimée après la première lecture.',
  'dashboard.noResults.title': 'Aucun résultat',
  'dashboard.noResults.body':
    'Aucune vidéo ne correspond à cette recherche. Essayez un autre terme ou réinitialisez les filtres.',
  'dashboard.loadError': 'Impossible de charger vos vidéos. Vérifiez votre connexion.',
  'dashboard.loadBlocked': "Impossible de charger vos vidéos. Le service n'est pas configuré correctement - le problème ne vient pas de vous.",
  'dashboard.expiresIn': 'Expire {when}',
  'dashboard.viewedAt': 'Consultée {when}',
  'dashboard.createdAt': 'Créée {when}',
  'dashboard.forRecipient': 'Pour {name}',

  'status.processing': 'En traitement',
  'status.ready': 'Prête',
  'status.opened': 'Lien ouvert',
  'status.playing': 'En cours de lecture',
  'status.watched': 'Consultée',
  'status.expired': 'Expirée',
  'status.deleted': 'Supprimée',
  'status.error': 'Erreur',

  'upload.title': 'Envoyer une vidéo',
  'upload.subtitle':
    'Elle sera convertie, protégée par un lien à usage unique, puis supprimée après la première lecture.',
  'upload.drop': 'Déposez votre vidéo',
  'upload.formats': "{formats} - jusqu'à {size}",
  'upload.choose': 'Choisir un fichier',
  'upload.progress': "Progression de l'envoi",
  'upload.inProgress': 'Envoi en cours…',
  'upload.converting': 'Conversion en cours…',
  'upload.cancelUpload': "Annuler l'envoi",
  'upload.processingNote':
    "Conversion en fragments sécurisés. Inutile d'attendre : générez le lien maintenant, il fonctionnera dès que ce sera terminé.",
  'upload.restart': 'Recommencer',
  'upload.error.format': 'Format non pris en charge. Utilisez un fichier MP4, MOV ou WebM.',
  'upload.error.tooLarge': 'Fichier trop volumineux (maximum {size}).',
  'upload.error.notVideo': 'Ce fichier ne ressemble pas à une vidéo valide.',
  'upload.error.unreadable': "Ce fichier n'a pas pu être lu comme une vidéo.",
  'upload.error.tooLong': 'Vidéo trop longue ({duration}). Maximum {max}.',
  'upload.error.failed': "L'envoi a échoué. Vérifiez votre connexion et réessayez.",
  'upload.error.transcode':
    'La conversion de cette vidéo a échoué. Le fichier a été supprimé. Essayez un autre format.',
  'upload.error.tracking': 'Suivi du traitement interrompu. Rechargez la page.',

  'config.expiry': 'Expiration du lien',
  'config.expiry1h': '1 heure',
  'config.expiry24h': '24 h',
  'config.expiry3d': '3 jours',
  'config.expiry7d': '7 jours',
  'config.expiryCustom': 'Date personnalisée',
  'config.expiryDate': "Date et heure d'expiration",
  'config.pin': "Code d'accès",
  'config.pinHint': '4 à 8 chiffres. À transmettre séparément du lien.',
  'config.advanced': 'Options avancées',
  'config.internalName': 'Nom interne',
  'config.internalNameHint': 'Visible uniquement par vous, jamais par le destinataire.',
  'config.recipient': 'Nom du destinataire',
  'config.recipientHint': 'Affiché dans le filigrane si celui-ci est activé.',
  'config.watermark': 'Filigrane',
  'config.watermarkNone': 'Aucun',
  'config.watermarkSubtle': 'Discret',
  'config.watermarkReinforced': 'Renforcé',
  'config.message': 'Message au destinataire',
  'config.messagePlaceholder': 'Optionnel - affiché avant la lecture',
  'config.submit': 'Créer le lien privé',
  'config.alwaysDeleted':
    'La suppression après consultation est toujours active et ne peut pas être désactivée.',
  'config.linkFailed': 'Impossible de générer le lien.',

  'ready.eyebrow': 'Lien généré',
  'ready.title': "Votre lien est prêt. Il ne servira qu'une fois.",
  'ready.meta': '{name} · {duration} · expire le {date}',
  'ready.stillProcessing':
    "Ce lien fonctionne déjà, mais la vidéo est encore en cours de traitement. S'il est ouvert tout de suite, le destinataire devra simplement patienter un instant.",
  'ready.secureLink': 'Lien sécurisé',
  'ready.copyFailed': 'Copie impossible. Sélectionnez le lien manuellement.',
  'ready.shareTitle': 'Vidéo à lecture unique',
  'ready.shareText': "Cette vidéo ne peut être visionnée qu'une seule fois.",
  'ready.pinWarning':
    "Le code d'accès n'est volontairement pas inclus dans le partage. Transmettez-le par un autre canal (SMS, appel), jamais dans le même message que le lien.",
  'ready.fragmentNote':
    "La partie du lien après le {hash} est le secret d'accès. Elle n'est jamais envoyée à nos serveurs - copiez le lien en entier.",
  'ready.protections': 'Protections actives',
  'ready.protectionSingle': 'Une seule session de lecture',
  'ready.protectionDelete': 'Suppression après consultation',
  'ready.protectionPin': "Code d'accès requis",
  'ready.protectionsNote':
    "Ces mesures garantissent une lecture unique. Elles ne peuvent pas empêcher une capture ou un enregistrement d'écran.",
  'ready.qr': 'QR code',
  'ready.qrAlt': 'QR code du lien sécurisé pour {name}',
  'ready.sendAnother': 'Envoyer une autre vidéo',
  'ready.backToDashboard': 'Retour au tableau de bord',
  'ready.leaveWarnTitle': "Vous n'avez pas encore copié ce lien",
  'ready.leaveWarnBody':
      "C'est le seul moment où il est affiché. Il n'est stocké nulle part : si vous quittez maintenant sans l'avoir copié ou partagé, personne - pas même vous - ne pourra le récupérer ensuite. Il faudrait révoquer le lien de cette vidéo et la renvoyer.",
  'ready.leaveAnyway': 'Quitter sans copier',
  'ready.copyNow': 'Copier le lien',
  'ready.watermarkNone': 'Aucun filigrane',
  'ready.watermarkSubtle': 'Filigrane discret',
  'ready.watermarkReinforced': 'Filigrane renforcé',

  'detail.notFound.title': 'Vidéo introuvable',
  'detail.notFound.body': "Cette vidéo n'existe plus ou ne vous appartient pas.",
  'detail.duration': 'Durée',
  'detail.size': 'Taille',
  'detail.created': 'Créée le',
  'detail.recipient': 'Destinataire',
  'detail.expiry': 'Expiration',
  'detail.viewedOn': 'Consultée le',
  'detail.deletedOn': 'Supprimée le',
  'detail.pinRequired': 'Requis',
  'detail.consumedNote':
    'Cette vidéo a été consultée. Le lien est définitivement inutilisable et les fichiers ont été supprimés du stockage.',
  'detail.failedNote':
    "Le traitement de cette vidéo a échoué. Aucun lien n'a été généré et les fichiers temporaires ont été supprimés.",
  'detail.lastError': 'Dernière erreur signalée par le serveur :',
  'detail.copyLink': 'Copier le lien',
  'detail.secretLost':
    "Le secret du lien n'est jamais stocké : il n'apparaît qu'à la génération. Révoquez ce lien et créez-en un nouveau si vous l'avez perdu.",
  'detail.revoke': 'Révoquer le lien',
  'detail.deleteNow': 'Supprimer maintenant',
  'detail.reuse': 'Réutiliser ces paramètres',
  'detail.revokeTitle': 'Révoquer ce lien ?',
  'detail.revokeBody':
    'Le lien cessera immédiatement de fonctionner. La vidéo sera ensuite supprimée.',
  'detail.revoked': 'Lien révoqué.',
  'detail.deleteTitle': 'Supprimer cette vidéo ?',
  'detail.deleteBody':
    'Le fichier source, les fragments et les miniatures seront détruits. Cette action est irréversible.',
  'detail.deleteStarted': 'Suppression lancée.',
  'detail.actionFailed': 'Action impossible pour le moment.',

  'settings.title': 'Compte et confidentialité',
  'settings.subtitle': "Ce que BOOMSHOT conserve, et ce qu'il ne peut pas garantir.",
  'settings.identity': 'Identité',
  'settings.anonymous': 'Compte anonyme',
  'settings.memberSince': 'Connecté depuis {date}',
  'settings.dataKept': 'Données conservées',
  'settings.dataKept1':
    "Après suppression d'une vidéo, BOOMSHOT ne garde qu'une trace minimale : statut, date de création, date de consultation, date de suppression, durée et le nom que vous avez choisi.",
  'settings.dataKept2':
    'Aucune adresse IP complète n’est stockée. Aucune miniature, aucun fragment vidéo et aucun fichier source ne subsiste.',
  'settings.limitsTitle': 'Limites réelles de la protection',
  'settings.limits1':
    "Une vidéo diffusée dans un navigateur peut toujours être copiée : capture d'écran, enregistrement d'écran, caméra externe filmant l'écran, ou extraction par un utilisateur techniquement averti.",
  'settings.limits2':
    "BOOMSHOT garantit qu'un lien n'ouvre qu'une seule session de lecture et que les fichiers sont ensuite détruits côté serveur. Il ne garantit pas l'impossibilité de copier l'image.",
  'settings.deleteAccount': 'Supprimer le compte',
  'settings.deleteAccountBody':
    'Toutes vos vidéos, vos liens et vos fichiers seront détruits. Cette action est irréversible.',
  'settings.deleteConfirmLabel': 'Tapez SUPPRIMER pour confirmer',
  'settings.deleteConfirmWord': 'SUPPRIMER',
  'settings.deleteSubmit': 'Supprimer définitivement mon compte',
  'settings.deleted': 'Compte supprimé.',
  'settings.signOutFailed': 'Déconnexion impossible pour le moment.',

  'viewer.checking': 'Vérification du lien…',
  'viewer.preparing': "Presque prêt - la vidéo de l'expéditeur est encore en préparation.",
  'viewer.eyebrow': 'Lecture unique',
  'viewer.title': "Cette vidéo ne peut être visionnée qu'une seule fois.",
  'viewer.subtitle':
    "Lancez-la lorsque vous êtes prêt et assurez-vous de disposer d'une connexion stable.",
  'viewer.sender': 'Expéditeur',
  'viewer.message': 'Message',
  'viewer.duration': 'Durée',
  'viewer.deadline': 'Date limite',
  'viewer.warning':
    "Dès que vous lancerez la lecture, le lien deviendra définitivement inutilisable. Il n'y aura ni relecture, ni retour en arrière, ni seconde session - même en cas de fermeture accidentelle de la page.",
  'viewer.start': 'Commencer la lecture unique',
  'viewer.startWithPin': 'Valider et commencer la lecture unique',
  'viewer.pinHint': "Ce code vous a été transmis séparément par l'expéditeur.",
  'viewer.pinWrong': 'Code incorrect.',
  'viewer.pinWrongRetry': 'Code incorrect. Réessayez dans {seconds} s.',
  'viewer.retryIn': 'Nouvelle tentative dans {seconds} s',
  'viewer.noPreload': "Aucun fragment vidéo n'est chargé avant votre confirmation.",
  'viewer.checkFailed': 'Impossible de vérifier ce lien pour le moment.',
  'viewer.claimFailed': "La session de lecture n'a pas pu être ouverte.",
  'viewer.unavailable.title': "Ce lien n'est plus valide",
  'viewer.unavailable.body':
    "Il a peut-être déjà été utilisé, révoqué, ou il n'a jamais existé. Pour des raisons de confidentialité, nous ne pouvons pas en dire davantage. Demandez un nouveau lien à l'expéditeur.",
  'viewer.expired.title': 'Ce lien a expiré',
  'viewer.expired.body':
    "La date limite fixée par l'expéditeur est passée et la vidéo a été supprimée. Demandez un nouveau lien si vous devez encore la consulter.",
  'viewer.used.title': 'Cette vidéo a déjà été ouverte',
  'viewer.used.body':
    "Une session de lecture a déjà été démarrée pour ce lien. Il ne peut plus en créer d'autre, et la vidéo a été supprimée.",
  'viewer.stillProcessing.title': 'Cette vidéo est encore en préparation',
  'viewer.stillProcessing.body':
    "Cela prend plus de temps que d'habitude. Le lien fonctionne bien - rouvrez-le dans quelques minutes, la vidéo devrait alors être prête.",
  'viewer.consumed.title': 'Vidéo consultée et supprimée',
  'viewer.consumed.body':
    'La lecture est terminée. Le lien est désormais inutilisable et les fichiers ont été détruits sur nos serveurs.',
  'viewer.error.title': 'Lecture impossible',

  'player.preloading': 'Préchargement sécurisé…',
  'player.tapToPlay': 'Toucher pour lire',
  'player.tapToPlayHint': "La lecture unique commence dès que vous appuyez sur lecture.",
  'player.stalled': 'Connexion instable - la lecture reprend automatiquement.',
  'player.play': 'Lancer la lecture',
  'player.pause': 'Mettre en pause',
  'player.mute': 'Couper le son',
  'player.unmute': 'Réactiver le son',
  'player.volume': 'Volume',
  'player.fullscreen': 'Passer en plein écran',
  'player.exitFullscreen': 'Quitter le plein écran',
  'player.progress': 'Progression de la lecture',
  'player.unsupported': 'Votre navigateur ne peut pas lire cette vidéo.',
  'player.fatal': 'La lecture a été interrompue et ne peut pas reprendre.',

  'notFound.title': 'Page introuvable',
  'notFound.body':
    "Cette adresse ne correspond à rien. Si vous avez reçu un lien de vidéo, vérifiez qu'il a été copié en entier - la partie après le {hash} est indispensable.",
  'notFound.home': "Retour à l'accueil",

  'apiError.network': 'Connexion indisponible. Vérifiez votre réseau.',
  'apiError.unauthenticated': 'Session expirée. Reconnectez-vous.',
  'apiError.forbidden': 'Accès refusé.',
  'apiError.notFound': 'Introuvable.',
  'apiError.conflict': 'Cette action a déjà été effectuée.',
  'apiError.rateLimited': 'Trop de tentatives. Réessayez dans un instant.',
  'apiError.badResponse': 'Réponse inattendue du serveur.',
  'apiError.internal': 'Une erreur interne est survenue.',
  'apiError.badRequest': 'Requête invalide.',

  'validation.required': 'Requis',
  'validation.invalidFormat': 'Format invalide',
  'validation.tooLong': 'Trop long',
  'validation.unsafeCharacters': 'Caractères non autorisés',
  'validation.email': 'Adresse email invalide',
  'validation.passwordMin': '10 caractères minimum',
  'validation.passwordComplexity': 'Doit contenir une minuscule, une majuscule et un chiffre',
  'validation.passwordMismatch': 'Les mots de passe ne correspondent pas',
  'validation.termsRequired': 'Vous devez accepter les conditions',
  'validation.pinDigits': 'Le code doit être numérique',
  'validation.pinMin': 'Au moins {min} chiffres',
  'validation.pinMax': 'Au plus {max} chiffres',
  'validation.messageTooLong': 'Message trop long (500 caractères max)',
  'validation.dateRequired': 'Choisissez une date',
  'validation.dateTooSoon': 'La date doit être au moins 5 minutes dans le futur',
  'validation.dateTooFar': 'La date ne peut pas dépasser 30 jours',
  'validation.confirmDelete': 'Tapez SUPPRIMER pour confirmer',

  'state.errorTitle': 'Une erreur est survenue',
};
